import { useLocation, useParams } from "react-router-dom";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getOrgDataById,
  listenDocDataByRef,
  queryCollection,
} from "../../models/DataFunctions";
import { FolderAccessManagement } from "./folder_main/FolderAccessManagement";
import { FolderAdministrationSection } from "./folder_main/FolderAdministrationSection";
import { FolderCollaboratorsSection } from "./folder_main/FolderCollaboratorsSection";
import { FolderDocumentsSection } from "./folder_main/FolderDocumentsSection";
import { FolderHeader } from "./folder_main/FolderHeader";

import { FolderInformationSection } from "./folder_sidebar/FolderInformationSection";
import { FolderMessagesSection } from "./folder_sidebar/FolderMessagesSection";
import { FolderModalsWrapper } from "./FolderModalsWrapper";
import { useAuth } from "../../auth/FirebaseAuth";
import { use, useEffect, useState } from "react";
import { useAppContext } from "../../config/AppContext";
import { addActivityLog } from "../../config/OnlineStatus";
import { Spin } from "antd";
import WaitingDisplay from "../../modals/WaitingDisplay";
import WaitingDisplay2 from "../../modals/WaitingDisplayFavoris";
import getTemporaryUrl from "../../api/getTemporaryUrl";
import { check_facture_mat } from "../../config/Helpers";
import deleteFolder from "../../api/delete/deleteFolder";
import { useSnackbar } from "notistack";
import uploadDropZoneTemporary from "../../api/upload/uploadDropZoneTemporary";
import transferFolderFiles from "../../api/folder/transferFolderFiles";
import { isFolderAdmin, isFolderClient } from "./FolderHelpers";
import { isFolderMaster } from "../../hexagone/VisibilityHelpers";
import { getUserById } from "../../models/UserFunctions";
import SmallSpinner from "../../loading/SmallSpinner";
import CustomAccordion from "../../layout/CustomAccordion";
import { FolderActivitySection } from "./folder_main/FolderActivitySection";
import { getCarnetDetails } from "../../hexagone_logement/utils";

export function FolderV2({
  userData,
  orgData,
  overrideId,
  navigateWorkspace,
  refreshFolders,
  workspaceData,
}) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();
  const [loadingData, setLoadingData] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [masterData, setMasterData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [folderData, setFolderData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [documentsarchi, setDocumentsArchi] = useState([]);

  const [thermalData, setThermalData] = useState([]);
  const [xmlData, setXmlData] = useState([]);
  const [modifthermalData, setModifThermalData] = useState([]);
  const [modifthermalXmlData, setModifThermalXmlData] = useState([]);
  const [modifthermalPhotoData, setModifThermalPhotoData] = useState([]);

  const [rapportData, setRapportData] = useState([]);
  const [architecterapportData, setArchitecteRapportData] = useState([]);

  const [operators, setOperators] = useState([]);
  const [all_operators, setAllOperators] = useState([]);
  const [conductor, setConductor] = useState(null);
  const [all_conductors, setAllConductors] = useState([]);
  const [experts, setExperts] = useState([]);
  const [all_experts, setAllExperts] = useState([]);
  const [all_partners, setAllPartners] = useState([]);
  const [partners, setPartners] = useState([]);
  const [assistants, setAssistants] = useState([]);
  const [assistant_options, setAssistantOptions] = useState([]);
  const [assistant_value, setAssistantValue] = useState(null);
  const [all_assistants, setAllAssistants] = useState([]);

  const [operator_options, setOperatorOptions] = useState([]);
  const [conductor_options, setConductorOptions] = useState([]);
  const [expert_options, setExpertOptions] = useState([]);
  const [all_repertories, setAllRepertories] = useState(false);
  const [partner_options, setPartnerOptions] = useState([]);

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const [dropped_files, setDroppedFiles] = useState([]);
  const [selected_dropped_files, setSelectedDroppedFiles] = useState([]);
  const [dropped_exists, setDroppedExists] = useState(false);

  const [operator_value, setOperatorValue] = useState(null);
  const [conductor_value, setConductorValue] = useState(null);
  const [expert_value, setExpertValue] = useState(null);
  const [partner_value, setPartnerValue] = useState(null);

  const [infiltrea, setInfiltrea] = useState(null);

  const [vision, setVision] = useState(null);

  const [messages, setMessages] = useState([]);
  const [missions_infiltrea, setMissionsInfiltrea] = useState([]);
  const [invoices_pennylane, setInvoicesPennylane] = useState([]);

  const [emails, setEmails] = useState([]);
  const [loadingTransfer, setLoadingTransfer] = useState(null);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [event_description, setEventDescription] = useState("");

  const [token, setToken] = useState("");
  const [loadingExperts, setLoadingExperts] = useState(false);
  const [loadingOperators, setLoadingOperators] = useState(false);
  const [loadingAssistants, setLoadingAssistants] = useState(false);
  const [loadingConductors, setLoadingConductors] = useState(false);
  const [reglement, setReglement] = useState("");
  const [payments, setPayments] = useState([]);
  const [slots, setSlots] = useState([]);
  const [users, setUsers] = useState([]);

  const [tags, setTags] = useState([]);

  const [tag_index, setTagIndex] = useState(0);

  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [actions, setActions] = useState(0);

  const [email_open, setEmailOpen] = useState(false);
  const [email_modif_thermal, setEmailModifThermal] = useState(false);
  const [email_for_xml, setEmailForXml] = useState(false);
  const [email_for_expert, setEmailForExpert] = useState(false);
  const [email_for_doc_request, setEmailForDocRequest] = useState(false);
  const [missingDocNames, setMissingDocNames] = useState([]);
  const [missingDocIds, setMissingDocIds] = useState([]);
  const [payment_open, setPaymentOpen] = useState(false);
  const [tag_open, setTagOpen] = useState(false);
  const [all_blocked, setAllBlocked] = useState(false);
  const [unsubscribe, setUnsubscribe] = useState(null);
  const [carnetDetails, setCarnetDetails] = useState(null);
  const [activity_opening, setActivityOpening] = useState(false);
  const [activity_logs, setActivityLogs] = useState([]);
  let location = useLocation();

  const handleFetchData = async () => {
    try {
      let times = [new Date().getTime()];

      // Parallel fetch for user and folder data
      const [folder, token] = await Promise.all([
        getDocDataById("folder", id),
        getOrRefreshFirebaseToken(),
      ]);

      if (folder === null) {
        handleClickVariant("Dossier introuvable", "error");
        navigateWorkspace("/folders");
        return;
      }

      let path = location.pathname;
      //check if there is /workspace/ in the path
      let workspace_path = path?.includes("workspace") ? true : false;

      if (
        (!workspaceData || workspaceData?.master_id !== folder.master_id) &&
        folder.master_id !== orgData.id
      ) {
        if (folder.master_id === orgData.id) {
          navigateWorkspace("/workspace/myself/folder/" + id);
          console.warn("Navigating to myself folder");
          return;
        } else {
          console.warn("Should be in a workspace to access this folder");

          let my_workspaces = await getArrayDocDataByID(
            "workspace",
            orgData.workspaces_id,
          );
          let matching_workspace = my_workspaces.find(
            (workspace) => workspace.master_id === folder.master_id,
          );
          if (matching_workspace) {
            navigateWorkspace("/folder/" + id, orgData, matching_workspace.id);
            console.warn("Navigating to folder in workspace");
            return;
          } else {
            // you should not be here
            handleClickVariant("Dossier introuvable", "error");
            navigateWorkspace("/folders");
            console.warn("Navigating to folders");
            return;
          }
        }
      }

      times.push(new Date().getTime());

      setReglement(folder.reglement || null);
      if (folder.reglement?.payments) {
        let payments = await getArrayDocDataByRef(folder.reglement?.payments);
        setPayments(payments);
      }
      if (folder.rapport?.slots) {
        let slots = await getArrayDocDataByRef(folder.rapport?.slots);
        setSlots(slots);
      }

      let access_denied = true;

      if (folder.master_id === orgData.id) {
        access_denied = false;
      } else if (folder.client_id === orgData.id) {
        access_denied = false;
      } else if (
        folder.partners_id.some((partner_id) => partner_id === orgData.id)
      ) {
        access_denied = false;
      }
      if (access_denied) {
        handleClickVariant("Accès non autorisé", "error");
        navigateWorkspace("/folders");
        return;
      }

      let user_filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];

      let users = await queryCollection("user", user_filters);
      setUsers(users);

      times.push(new Date().getTime());

      // Parallel fetch for org and folder-related data based on org type
      let client, master;

      if (folder.client_type !== "particulier") {
        client = await getOrgDataById(folder.client_id);
        setClientData(client);
      }

      if (isFolderMaster(orgData, folder)) {
        master = orgData;
        setMasterData(orgData);

        let infiltrea_filters = [
          {
            field: "folder_ref",
            operator: "==",
            value: folder.ref,
          },
        ];
        let missions = await queryCollection(
          "mission_infiltrea",
          infiltrea_filters,
        );
        setMissionsInfiltrea(missions);
        let pennylane_filters = [
          {
            field: "folder_ref",
            operator: "==",
            value: folder.ref,
          },
        ];
        let penny = await queryCollection(
          "pennylane_facture",
          pennylane_filters,
        );
        setInvoicesPennylane(penny);
      } else if (isFolderClient(orgData, folder)) {
        master = await getOrgDataById(folder.master_id);
        client = orgData;
        setMasterData(master);
        setClientData(orgData);
      } else {
        master = await getOrgDataById(folder.master_id);

        setMasterData(master);
      }

      times.push(new Date().getTime());

      if (
        !folder.intervention_realisee &&
        folder.event_ref &&
        folder.dateintervention &&
        folder.dateintervention.seconds < new Date().getTime() / 1000
      ) {
        await updateDocDataFieldApi(
          folder.ref,
          "intervention_realisee",
          true,
          prefix,
        );
      }

      let filters_activity_logs = [
        {
          field: "folder_ref",
          operator: "==",
          value: folder.ref,
        },
      ];

      // Fetch remaining data
      let [
        modif_thermal_photo_document,
        master_users,
        all_clientusers,
        operators,
        assistants,
        conductor,
        partners,
        all_partners,
        documents,
        _,

        emails,
        documentsarchi,
        activity_logs,
      ] = await Promise.all([
        getDocDataByRef(folder.modif_thermal_photo_document),
        getArrayDocDataByID("user", orgData.users_id),
        client ? getArrayDocDataByID("user", client.users_id) : [],
        folder.members_id
          ? getArrayDocDataByID("user", folder.members_id)
          : Promise.resolve([]),
        folder.assistants_id
          ? getArrayDocDataByID("user", folder.assistants_id)
          : Promise.resolve([]),
        folder.conductor_id
          ? getUserById(folder.conductor_id)
          : Promise.resolve(null),
        folder.partners_id
          ? getArrayDocDataByID("org", folder.partners_id || [])
          : Promise.resolve([]),
        queryCollection("org", [
          {
            field: "masters_id",
            operator: "array-contains",
            value: master.id,
          },
        ]),
        getArrayDocDataByRef(folder.documents || []),
        handleGetAllTempUrls(token),
        queryCollection(
          "email_sent",
          [
            { field: "org_id", operator: "==", value: master.id },
            { field: "folder_ref", operator: "==", value: folder.ref },
          ],
          1000,
          "date",
          "desc",
        ),
        getArrayDocDataByRef(folder.pieces_pmr ? folder.pieces_pmr : []),
        queryCollection("activity_log", filters_activity_logs),
      ]);

      documents = documents.map((document) =>
        check_facture_mat(document, folder),
      );

      times.push(new Date().getTime());

      // add to documents to documentarchi  with pmr = true
      // for (let document of documents) {
      //  if (document.pmr) {
      //    documentsarchi.push(document);
      //    documents = documents.filter((doc) => doc.id !== document.id);
      //  }
      // }
      setActivityLogs(activity_logs);

      setInfiltrea(folder.infiltrea);

      modif_thermal_photo_document.modif_thermal = true;

      // Process fetched data
      const tags = folder.tags || [];
      const my_tag = tags.filter(
        (tag) =>
          tag.org_id === orgData.id ||
          (!workspaceData &&
            (folder.admins_id || []).map((a) => a.id).includes(tag.org_id)),
      );

      const tags2 = folder.tags2 || [];
      const my_tag2 = tags2.filter(
        (tag) =>
          tag.org_id === orgData.id ||
          (!workspaceData &&
            (folder.admins_id || []).map((a) => a.id).includes(tag.org_id)),
      );

      const my_tags = my_tag.concat(my_tag2 || []) || [];

      setTags(my_tags);
      const counters = folder.counters;
      const my_counter = counters.find(
        (counter) => counter.org_id === orgData.id,
      );
      if (!my_counter) {
        console.error("No counter found for this org " + orgData.id);
      }
      setActions(my_counter.counter);

      const vision = folder.visions.find(
        (vision) => vision.org_id === orgData.id,
      );
      setVision(vision);

      const all_operators = master_users.filter(
        (user) => user.role === "operator",
      );
      const all_assistants = master_users.filter(
        (user) => user.role === "secretary",
      );
      const operator_options = all_operators.map((operator) => ({
        label: operator.display_name,
        value: operator.id,
      }));
      const assistant_options = all_assistants.map((operator) => ({
        label: operator.display_name,
        value: operator.id,
      }));

      if (folder.members_id && folder.members_id.length > 0) {
        let member = folder.members_id[0];
        let corresponding_user = all_operators.find(
          (user) => user.id === member.id,
        );
        if (
          corresponding_user &&
          corresponding_user.display_name != folder.operator_name
        ) {
          await updateDocDataFieldApi(
            folder.ref,
            "operator_name",
            corresponding_user.display_name,
            prefix,
          );
        }
      }

      const all_conductors = all_clientusers;
      // map a dict wuth the display name and the id
      const conductor_options = all_conductors.map((conductor) => ({
        label: conductor.display_name,
        value: conductor.id,
        id: conductor.id,
      }));
      // map a dict wuth the display name and the id

      let partner_options = all_partners
        .filter(
          (partner) =>
            partner.id !== folder.client_id &&
            !(folder.partners_id || []).map((p) => p.id).includes(partner.id),
        )
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((partner) => ({
          label: partner.name,
          value: partner.id,
        }));

      if (workspaceData) {
        // only display affiliated partners in workspace
        partner_options = partner_options.filter((partner) =>
          workspaceData.affiliated_partners_id?.includes(partner.value),
        );
      }

      const thermal = {
        id: "thermal",
        name: "Documents étude thermique",
        state: folder.thermal?.state,
        viewers_id: folder.thermal?.viewers_id,
      };

      let access_documents = [thermal, ...documents];
      times.push(new Date().getTime());
      const modif_thermal = {
        id: "modif_thermal",
        name: "Documents étude thermique",
        state: folder.modif_thermal?.state,
        viewers_id: folder.modif_thermal?.viewers_id,
      };

      if (folder.modif_thermal?.activated && !folder.modif_thermal?.xml) {
        await updateDocDataFieldApi(
          folder.ref,
          "modif_thermal.xml",
          {
            state: "locked",
            file: null,
            upload_date: getFlutterTime(),
          },
          prefix,
        );
      }
      const modif_thermal_xml = {
        id: "modif_thermal_xml",
        name: "Xml de mise à jour",
        state: folder.modif_thermal?.xml?.state,
        viewers_id: folder.modif_thermal?.viewers_id,
      };

      const rapport = {
        id: "rapport",
        name: "Rapports de fin de chantier",
        state: folder.rapport?.state,
      };
      const rapport_architecte = {
        id: "rapport_architecte",
        name: "Rapports Architecte",
        state: folder.rapport_architecte?.state,
      };

      access_documents.push(modif_thermal);

      setFolderData(folder);

      documents = documents.sort((a, b) => (a.name.includes("BE -") ? -1 : 1));

      setDocuments(documents);
      setDocumentsArchi(documentsarchi);
      setThermalData(thermal);
      setXmlData({
        id: "xml",
        name: "XML",
        state: folder.xml?.state,
        upload_date: folder.xml?.upload_date,
        accepted_formats: [".zip"],
      });

      setModifThermalData(modif_thermal);
      setModifThermalXmlData(modif_thermal_xml);
      setModifThermalPhotoData(modif_thermal_photo_document);
      setRapportData(rapport);
      setArchitecteRapportData(rapport_architecte);
      setOperators(operators);
      setAllOperators(all_operators);
      setAssistants(assistants);
      setAllAssistants(all_assistants);
      setConductor(conductor);
      setAllConductors(all_conductors);
      setAllPartners(all_partners);
      setPartners(partners);
      setOperatorOptions(operator_options);
      setAssistantOptions(assistant_options);
      setConductorOptions(conductor_options);
      setPartnerOptions(partner_options);
      setToken(token);
      setEmails(emails);

      if (folder.carnet_id) {
        try {
          let resp = await getCarnetDetails(folder.id, token, prefix);
          if (resp?.success === false) {
            console.info("Cant fetch carnet details:", resp.error);
          } else {
            setCarnetDetails(resp.carnetDetails);
          }
        } catch (error) {
          console.info("Cant fetch carnet details:", error);
        }
      }
      times.push(new Date().getTime());

      setLoadingData(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    let end_time = new Date().getTime();
  };
  const refreshFolder = (data) => {
    const folder = data;
    setFolderData(folder);
  };
  const handleInitiateActivity = async () => {
    await addActivityLog(
      "Ouverture du dossier",
      folderData.ref,
      orgData.id,
      userData.id,
      "folder_opened",
      prefix,
    );
  };

  const handleGetAllTempUrls = async (token = null) => {
    if (!token) {
      token = await getOrRefreshFirebaseToken();
    }
    await getTemporaryUrl(token, "all", "none", id, prefix);
  };
  useEffect(() => {
    if (folderData) {
      const newUnsubscribe = listenDocDataByRef(folderData.ref, refreshFolder);

      return () => {
        newUnsubscribe(); // Always unsubscribe from the current listener
      };
    }
  }, [folderData?.ref]); // Only depends on folderData.ref

  useEffect(() => {
    if ((orgData, userData)) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [orgData, userData, id]); // Dependency array ensures this runs when currentUser changes

  useEffect(() => {
    if (folderData && orgData && userData && !activity_opening) {
      setActivityOpening(true);
      handleInitiateActivity();
    }
  }, [folderData, orgData, userData]);

  const handleSetEmailModalOpen = (
    open,
    modif_thermal = false,
    doc_request = false,
    doc_names = [],
    doc_ids = [],
  ) => {
    setEmailModifThermal(modif_thermal);
    if (doc_request) {
      setEmailForDocRequest(true);
      setMissingDocNames(doc_names);
      setMissingDocIds(doc_ids);
    }
    setEmailOpen(open);
  };
  const handleOpenTag = (index) => {
    setTagOpen(true);
    setTagIndex(index);
  };

  const show_favoris = useState(Math.random() > 0.5)[0];

  const [loading_drop = false, setLoadingDrop] = useState(false);
  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
    setSelectedDroppedFiles(new_files);
  };

  const sendToDrop = async (file) => {
    setLoadingDrop(true);

    let new_files = [];

    const file_url = file.url;
    const file_name = file.name;
    const bytes = await fetch(file_url).then((res) => res.arrayBuffer());

    let res = await uploadDropZoneTemporary(token, bytes, file_name, prefix);
    let url = res.url;
    let name = res.name;
    new_files = [...new_files, { url: url, name: name }];

    setDroppedFiles(new_files);
    setSelectedDroppedFiles(new_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const handleSetReglementDone = async () => {
    try {
      const filters = [
        {
          field: "folder",
          operator: "==",
          value: folderData.ref,
        },
      ];

      const events = await queryCollection("event", filters);
      const new_state = folderData.reglement_state === "done" ? null : "done";

      // Prepare all update operations
      const updateOperations = [
        updateDocDataFieldApi(
          folderData.ref,
          "reglement_state",
          new_state,
          prefix,
        ),
        updateDocDataFieldApi(
          folderData.ref,
          "finalised_date",
          new_state === "done" ? getFlutterTime() : null,
          prefix,
        ),
        // Update all events in parallel
        ...events.map((event) =>
          updateDocDataFieldApi(
            event.ref,
            "reglement_state",
            new_state,
            prefix,
          ),
        ),
      ];

      // Execute all updates in parallel
      await Promise.all(updateOperations);

      // Handle post-update logic
      if (new_state === "done") {
        await addActivityLog(
          "Dossier finalisé",
          folderData.ref,
          orgData.id,
          userData.id,
          "folder_finalized",
          prefix,
        );
        handleClickVariant("Dossier passé en finalisé", "success");
      } else {
        handleClickVariant("Marquage retiré", "success");
      }

      //forcePageReload();
    } catch (error) {
      console.error("Error updating rapport:", error);
      handleClickVariant("Erreur lors de la mise à jour", "error");
    } finally {
    }
  };

  const transferFiles = async (document_id) => {
    try {
      const token = await getOrRefreshFirebaseToken();
      if (document_id === "xml" || document_id === "modif_thermal_xml") {
        let correct = check_files_are_all_zip_or_xml(selected_dropped_files);
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip ou .xml",
            "error",
          );
          return;
        }
      } else {
        // check none of the files are zip or xml
        let correct = check_files_no_xml_or_zip(selected_dropped_files);
        if (!correct) {
          handleClickVariant(
            "Les fichiers ne doivent pas être au format .zip ou .xml",
            "error",
          );
          return;
        }
      }
      if (document_id === "mo") {
        let correct = check_files_are_all_zip_or_xml(selected_dropped_files);
        if (!correct) {
          handleClickVariant(
            "Les fichiers doivent être au format .zip ou .xml",
            "error",
          );
          return;
        }
      }
      await transferFolderFiles(
        document_id,
        id,
        selected_dropped_files,
        token,
        prefix,
      );
      let repo_name = await translateDocumentId(document_id);

      await addActivityLog(
        "Documents déposés " + repo_name,
        folderData.ref,
        orgData.id,
        userData.id,
        "file_drop",
        prefix,
      );

      let new_files = dropped_files.filter(
        (file) => !selected_dropped_files.includes(file),
      );
      setDroppedFiles(new_files);
      setSelectedDroppedFiles(new_files);

      if (new_files.length === 0) {
        setDroppedExists(false);
      }

      handleFetchData();
    } catch (error) {
      console.error("Error transferring files:", error);
    }
  };

  // loading || !currentUser || !userData
  if (!orgData || loadingData) {
    return (
      <div className="h-screen flex flex-col gap-2 left-0 top-0  w-full items-center justify-center">
        <SmallSpinner></SmallSpinner>

        {show_favoris ? (
          <WaitingDisplay
            title="Posez vos questions via le chat"
            subtitle="Nous sommes là pour vous aider (questions sur hexagone & bugs)"
          ></WaitingDisplay>
        ) : (
          <WaitingDisplay2
            title="Ajoutez hexagone à vos favoris"
            subtitle="Pour un accès rapide à votre espace de travail"
          ></WaitingDisplay2>
        )}
      </div>
    );
  }

  return (
    <div
      className={`w-full  h-full overflow-auto flex flex-row pb-40 justify-start   `}
    >
      <FolderModalsWrapper
        email_open={email_open}
        setEmailOpen={setEmailOpen}
        setEmailForXml={setEmailForXml}
        setEmailForExpert={setEmailForExpert}
        setEmailModifThermal={setEmailModifThermal}
        setEmailForDocRequest={setEmailForDocRequest}
        email_for_expert={email_for_expert}
        email_for_xml={email_for_xml}
        email_modif_thermal={email_modif_thermal}
        email_for_doc_request={email_for_doc_request}
        selected_doc_names={missingDocNames}
        selected_doc_ids={missingDocIds}
        navigateWorkspace={navigateWorkspace}
        tag_open={tag_open}
        setTagOpen={setTagOpen}
        folderData={folderData}
        orgData={orgData}
        masterData={masterData}
        id={id}
        handleFetchData={handleFetchData}
        tag_index={tag_index}
        setTagIndex={setTagIndex}
        prefix={prefix}
        handleClickVariant={handleClickVariant}
        workspaceData={workspaceData}
      />
      <div className="h-fit flex flex-col w-full px-4 max-w-c1k ">
        {/* Left Column */}
        <div className="h-fit flex flex-col w-full px-4 max-w-c1k">
          <FolderHeader
            handleSetReglementDone={handleSetReglementDone}
            setEmailOpen={setEmailOpen}
            setEmailForXml={setEmailForXml}
            setEmailModifThermal={setEmailModifThermal}
            setEmailForExpert={setEmailForExpert}
            setEmailForDocRequest={setEmailForDocRequest}
            setMissingDocNames={setMissingDocNames}
            setMissingDocIds={setMissingDocIds}
            handleSetEmailModalOpen={handleSetEmailModalOpen}
            all_repertories={all_repertories}
            setAllRepertories={setAllRepertories}
            navigateWorkspace={navigateWorkspace}
            userData={userData}
            orgData={orgData}
            folderData={folderData}
            handleFetchData={handleFetchData}
            actions={actions}
            vision={vision}
            tags={tags}
            clientData={clientData}
            all_blocked={all_blocked}
            isHovered={isHovered}
            setIsHovered={setIsHovered}
            handleOpenTag={handleOpenTag}
            handleClickVariant={handleClickVariant}
            prefix={prefix}
            id={id}
            workspaceData={workspaceData}
            masterData={masterData}
            carnetDetails={carnetDetails}
          />
          <div className="flex flex-col gap-1">
            <FolderAccessManagement
              orgData={orgData}
              userData={userData}
              handleFetchData={handleFetchData}
              masterData={masterData}
              loading_drop={loading_drop}
              dropped_files={dropped_files}
              selected_dropped_files={selected_dropped_files}
              setSelectedDroppedFiles={setSelectedDroppedFiles}
              onDelete={onDelete}
              access_loading={loadingTransfer}
              id={id}
              prefix={prefix}
              folderData={folderData}
              handleClickVariant={handleClickVariant}
              setAllBlocked={setAllBlocked}
              clientData={clientData}
              partners={partners}
              setLoadingDrop={setLoadingDrop}
              setDroppedFiles={setDroppedFiles}
              setDroppedExists={setDroppedExists}
              setEmailOpen={setEmailOpen}
            />

            <FolderDocumentsSection
              thermalData={thermalData}
              xmlData={xmlData}
              modifthermalData={modifthermalData}
              modifthermalXmlData={modifthermalXmlData}
              modifthermalPhotoData={modifthermalPhotoData}
              rapportData={rapportData}
              architecterapportData={architecterapportData}
              documents={documents}
              documentsarchi={documentsarchi}
              setEmailForExpert={setEmailForExpert}
              setEmailForXml={setEmailForXml}
              setEmailOpen={setEmailOpen}
              setDocumentsArchi={setDocumentsArchi}
              setDroppedFiles={setDroppedFiles}
              setDroppedExists={setDroppedExists}
              setSelectedDroppedFiles={setSelectedDroppedFiles}
              orgData={orgData}
              userData={userData}
              dropped_exists={dropped_exists}
              folderData={folderData}
              all_repertories={all_repertories}
              transferFiles={transferFiles}
              loadingTransfer={loadingTransfer}
              setLoadingTransfer={setLoadingTransfer}
              overrideId={overrideId}
              navigateWorkspace={navigateWorkspace}
              handleFetchData={handleFetchData}
              prefix={prefix}
              reglement={reglement}
              setReglement={setReglement}
              slots={slots}
              setSlots={setSlots}
              setPaymentOpen={setPaymentOpen}
              clientData={clientData}
              payments={payments}
              setPayments={setPayments}
              users={users}
              setFolderData={setFolderData}
              handleClickVariant={handleClickVariant}
              handleSetReglementDone={handleSetReglementDone}
            />

            {(isFolderAdmin(orgData, folderData) ||
              isFolderClient(orgData, folderData)) && (
              <FolderCollaboratorsSection
                orgData={orgData}
                userData={userData}
                operators={operators}
                operator_value={operator_value}
                setOperatorValue={setOperatorValue}
                assistants={assistants}
                assistant_value={assistant_value}
                setAssistantValue={setAssistantValue}
                conductor={conductor}
                conductor_value={conductor_value}
                setConductorValue={setConductorValue}
                all_partner={all_partners}
                partners={partners}
                partner_options={partner_options}
                setPartnerValue={setPartnerValue}
                operator_options={operator_options}
                assistant_options={assistant_options}
                handleFetchData={handleFetchData}
                folderData={folderData}
                conductor_options={conductor_options} // conductor options is actually all client users. Legacy
                all_operators={all_operators}
                all_experts={all_experts}
                all_conductors={all_conductors}
                all_assistants={all_assistants}
                id={id}
                handleClickVariant={handleClickVariant}
                prefix={prefix}
              />
            )}
            <FolderActivitySection
              orgData={orgData}
              userData={userData}
              handleFetchData={handleFetchData}
              missions_infiltrea={missions_infiltrea}
              invoices_pennylane={invoices_pennylane}
              folderData={folderData}
              activity_logs={activity_logs}
              emails={emails}
              logs={activity_logs}
            ></FolderActivitySection>
            {isFolderAdmin(orgData, folderData) && (
              <FolderAdministrationSection
                orgData={orgData}
                userData={userData}
                handleFetchData={handleFetchData}
                missions_infiltrea={missions_infiltrea}
                invoices_pennylane={invoices_pennylane}
                folderData={folderData}
                activity_logs={activity_logs}
                emails={emails}
                logs={activity_logs}
              />
            )}
          </div>{" "}
        </div>{" "}
      </div>
      {/* Right Column */}
      <div className="h-fit max-w-full flex flex-col 4xl:flex-row items-start gap-x-6 gap-y-1  mt-10 px-4  ">
        <FolderMessagesSection
          folderData={folderData}
          messages={messages}
          orgData={orgData}
          userData={userData}
          setMessages={setMessages}
          masterData={masterData}
          dropped_files={dropped_files}
          dropped_exists={dropped_exists}
          resetDroppedFiles={setDroppedFiles}
          sendToDrop={sendToDrop}
          navigateWorkspace={navigateWorkspace}
          prefix={prefix}
          id={id}
          workspaceData={workspaceData}
        />

        <FolderInformationSection
          folderData={folderData}
          orgData={orgData}
          userData={userData}
          clientData={clientData}
          masterData={masterData}
          handleFetchData={handleFetchData}
          setFolderData={setFolderData}
          prefix={prefix}
          handleClickVariant={handleClickVariant}
        />
      </div>
    </div>
  );
}

export const check_files_are_all_zip_or_xml = (dropped_files) => {
  for (let file of dropped_files) {
    if (!file.name.endsWith(".zip") && !file.name.endsWith(".xml")) {
      return false;
    }
  }
  return true;
};

export const check_files_no_xml_or_zip = (dropped_files) => {
  for (let file of dropped_files) {
    if (file.name.endsWith(".zip") || file.name.endsWith(".xml")) {
      return false;
    }
  }
  return true;
};

export async function translateDocumentId(type) {
  let doc_name = "";
  try {
    let doc = await getDocDataById("document", type);
    if (doc) {
      doc_name = doc.name;
      return "Document " + doc_name;
    } else {
      switch (type) {
        case "thermal":
          return "Etude thermique";
        case "modif_thermal":
          return "Mise à jour étude thermique";
        case "modif_thermal_xml":
          return "XML de mise à jour";
        case "xml":
          return "XML";
        case "rapport":
          return "Rapport";
        case "rapport_architecte":
          return "Rapport Architecte";
        default:
          return type;
      }
    }
  } catch (e) {}
}
